var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Arc } from '../../../shapes/index';
import { createWidgetGroup, num, setState } from '../../helpers';
import { getActiveDashboard } from '../../theme';
import { attachPolarSliceHover } from '../core/interaction';
import { polarToXY } from '../core/scales';
export function buildPolarSlices(group, app, data, size, colors, options) {
    var _a;
    if (options === void 0) { options = {}; }
    var innerR = (_a = options.innerRadius) !== null && _a !== void 0 ? _a : 0;
    var outerR = size / 2 - 10;
    var cx = size / 2;
    var cy = size / 2;
    var total = data.reduce(function (a, b) { return a + b; }, 0) || 1;
    var startAngle = -Math.PI / 2;
    data.forEach(function (val, i) {
        var sweep = (val / total) * Math.PI * 2;
        var endAngle = startAngle + sweep;
        group.add(new Arc({
            x: cx - outerR,
            y: cy - outerR,
            innerRadius: innerR,
            radius: outerR,
            startAngle: startAngle,
            endAngle: endAngle,
            fill: colors[i % colors.length],
            stroke: getActiveDashboard().pieStroke,
            strokeWidth: 1,
            listening: false,
        }));
        if (options.showLabels !== false && sweep > 0.15) {
            var mid = (startAngle + endAngle) / 2;
            var lr = (outerR + innerR) / 2;
            var _a = __read(polarToXY(cx, cy, lr, mid), 2), lx = _a[0], ly = _a[1];
            var pct = Math.round((val / total) * 100);
            group.add(app.text({
                text: "".concat(pct, "%"),
                x: lx - 10,
                y: ly - 6,
                fontSize: 10,
                fill: getActiveDashboard().text,
                listening: false,
            }));
        }
        startAngle = endAngle;
    });
}
export function buildRadarChart(group, app, props) {
    var _a, _b;
    var size = num(props, 'size', 200);
    var data = (_a = props.data) !== null && _a !== void 0 ? _a : [4, 6, 3, 7, 5];
    var labels = (_b = props.categories) !== null && _b !== void 0 ? _b : data.map(function (_, i) { return "A".concat(i + 1); });
    var cx = size / 2;
    var cy = size / 2;
    var max = Math.max.apply(Math, __spreadArray(__spreadArray([], __read(data), false), [1], false));
    var r = size / 2 - 24;
    var n = data.length;
    for (var ring = 1; ring <= 4; ring++) {
        var rr = (r * ring) / 4;
        var pts = [];
        for (var i = 0; i < n; i++) {
            var a = (i / n) * Math.PI * 2 - Math.PI / 2;
            pts.push(cx + rr * Math.cos(a), cy + rr * Math.sin(a));
        }
        group.add(app.polygon({ points: pts, fill: null, stroke: getActiveDashboard().chartGrid, strokeWidth: 1, listening: false }));
    }
    var dataPts = [];
    data.forEach(function (v, i) {
        var a = (i / n) * Math.PI * 2 - Math.PI / 2;
        var dr = (v / max) * r;
        dataPts.push(cx + dr * Math.cos(a), cy + dr * Math.sin(a));
        group.add(app.text({
            text: labels[i],
            x: cx + (r + 12) * Math.cos(a) - 8,
            y: cy + (r + 12) * Math.sin(a) - 6,
            fontSize: 10,
            fill: getActiveDashboard().textMuted,
            listening: false,
        }));
    });
    dataPts.push(dataPts[0], dataPts[1]);
    group.add(app.polygon({
        points: dataPts,
        fill: getActiveDashboard().chartArea,
        stroke: getActiveDashboard().chartLine,
        strokeWidth: 2,
        listening: false,
    }));
    attachPolarSliceHover(app, group, props, size, data.map(function () { return 1; }), labels.map(function (l, i) { return "".concat(l, ": ").concat(data[i]); }));
    setState(group, { size: size, data: data, labels: labels });
}
export function createPieWidget(app, type, props, innerRadius) {
    var _a, _b;
    if (innerRadius === void 0) { innerRadius = 0; }
    var size = num(props, 'size', 150);
    var data = (_a = props.data) !== null && _a !== void 0 ? _a : [30, 25, 20, 25];
    var rawColors = Array.isArray(props.colors) ? props.colors : undefined;
    var userColors = props.hasUserColors === true
        ? rawColors
        : !props._chartRebuild && (rawColors === null || rawColors === void 0 ? void 0 : rawColors.length)
            ? rawColors
            : undefined;
    var colors = (userColors === null || userColors === void 0 ? void 0 : userColors.length) ? userColors : __spreadArray([], __read(getActiveDashboard().series), false);
    var resolvedInner = typeof props.innerRadius === 'number'
        ? props.innerRadius
        : innerRadius > 0
            ? innerRadius
            : type === 'doughnutChart'
                ? Math.round(size * 0.42)
                : 0;
    var group = createWidgetGroup(app, type, props);
    buildPolarSlices(group, app, data, size, colors, {
        innerRadius: resolvedInner,
        showLabels: props.showLabels !== false,
    });
    var labels = (_b = props.labels) !== null && _b !== void 0 ? _b : data.map(function (_, i) { return "Slice ".concat(i + 1); });
    attachPolarSliceHover(app, group, props, size, data, labels.map(function (l, i) { return "".concat(l, ": ").concat(data[i]); }), resolvedInner);
    // Persist user colors only — theme series resolved live on each rebuild
    setState(group, __assign(__assign({ size: size, data: data, labels: labels, innerRadius: resolvedInner }, (userColors ? { colors: userColors } : { colors: [] })), { hasUserColors: Boolean(userColors === null || userColors === void 0 ? void 0 : userColors.length) }));
    return group;
}
